export enum StatusCode {
  pending = 'PENDING',
  done = 'DONE',
  error = 'ERROR'
}
